module.exports = __webpack_public_path__ + "img/12.BX.f077e3ae.jpg";